// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"71f5ac4b","513":"04951832","703":"e011b85e","787":"5d0fb425"}[chunkId] + ".chunk.js";
};